<template>
  <div>
    <h3 class="my-auto">
      <b-button @click.prevent="backtolist" variant="outline-primary">&lt; Return to list</b-button>
      <span v-if="company_id > 0" class="ml-4">{{company_name}}</span>
      <span v-if="company_id < 0" class="ml-4">Add Company</span>
    </h3>
    <b-tabs class="col-12 px-0 mx-0 mt-2" content-class="mt-3">
      <b-tab class="px-0 col-12 border-0">
        <template v-slot:title>
          <div class="col-12 text-center">
            General Information
          </div>
        </template>
        <b-card no-body class="border-0 mx-0 px-0 pl-0 pr-0 col-12">
          <b-row>
          <!-- div class="col-5 form-inline" -->
          <div class="col-8">
          <!-- form class="form-inline" autocomplete=off @submit.stop.prevent-->
          <form autocomplete=off @submit.stop.prevent>
            <b-form-group 
              label-cols="4"
              label="Company name"
              class="col-12"
              invalid-feedback="Company name cannot be blank"
            >
              <b-form-input  
                id="company_name" 
                :state="company_name_valid"
                class="form-control col-7"
                v-model="company_name"
                v-on:change="savefield('g_companies',company_id,'company_name',company_name)" 
                autocomplete="off"
              >
              </b-form-input>
            </b-form-group>
            <b-form-group 
              label-cols="4"
              label="Company address"
              class="col-12"
              invalid-feedback="Company address cannot be blank"
            >
              <b-form-input  
                id="company_address_1" 
                :state="company_address_valid"
                class="form-control col-7"
                v-model="company_address_1"
                v-on:change="savefield('g_companies',company_id,'company_address_1',company_address_1)" 
                autocomplete="off"
              >
              </b-form-input>
            </b-form-group>
            <b-form-group 
              label-cols="4"
              label=""
              class="col-12"
              invalid-feedback="Company address cannot be blank"
            >
              <b-form-input  
                id="company_address_2" 
                :state="company_address_valid"
                class="form-control col-7"
                v-model="company_address_2"
                v-on:change="savefield('g_companies',company_id,'company_address_2',company_address_2)" 
                autocomplete="off"
              >
              </b-form-input>
            </b-form-group>
            <b-form-group 
              label-cols="4"
              label="Zip code"
              class="col-12"
              invalid-feedback="Company address cannot be blank"
            >
              <b-form-input  
                id="company_zip_code" 
                :state="company_address_valid"
                class="form-control col-7"
                v-model="company_zip_code"
                v-on:change="savefield('g_companies',company_id,'company_zip_code',company_zip_code)" 
                autocomplete="off"
              >
              </b-form-input>
            </b-form-group>
            <b-form-group 
              label-cols="4"
              label="City"
              class="col-12"
              invalid-feedback="Company address cannot be blank"
            >
              <b-form-input  
                id="company_city" 
                :state="company_address_valid"
                class="form-control col-7"
                v-model="company_city"
                v-on:change="savefield('g_companies',company_id,'company_city',company_city)" 
                autocomplete="off"
              >
              </b-form-input>
            </b-form-group>
            <b-form-group 
              label-cols="4"
              label="Country"
              class="col-12"
              invalid-feedback="You must select a country"
            >
              <b-form-select  
                id="company_country_id" 
                :state="company_country_id_valid"
                class="form-control col-7"
                v-model="company_country_id"
                :options="countries"
                v-on:change="savefield('g_companies',company_id,'company_country_id',company_country_id)" 
                autocomplete="off"
              >
              </b-form-select>
            </b-form-group>

            <b-form-group 
              label-cols="4"
              label="Company registration number"
              class="col-12"
              invalid-feedback="Company registration number cannot be blank"
            >
              <b-form-input  
                id="company_registration_number" 
                :state="company_address_valid"
                class="form-control col-7"
                v-model="company_registration_number"
                v-on:change="savefield('g_companies',company_id,'company_registration_number',company_registration_number)" 
                autocomplete="off"
              >
              </b-form-input>
            </b-form-group>
            <div class="form-group col-12 mt-4">
              <b-button 
                v-if="company_id < 1" 
                @click.prevent="company_create" 
                class="mt-10"
                variant="primary"
              >
                Save New Company
              </b-button>
            </div>
          </form>
          </div>
          <div class="col-6">
            <div v-if="company_id > 0" class="form-inline form-group col-12">
              <span class="col-12 px-0 mx-0 pt-2 pb-4">Labels</span><br>
                <span v-bind:key="label.id" v-for="label in labels" :style="{ 'background': '#'+label.color}" class="mr-2 py-1 pl-2 pr-2 rounded">
                  {{ label.label }}
                  <span 
                    @click.stop.prevent="removelabel(label.id)"

                  >
                    <fa-icon name="trash-alt" />
                  </span>
                </span>
                <span 
                  v-show="addinglabel==0"
                  class="icon-plus pt-0 text-primary"
                  :class="labels.length==0?'pt-2':'pt-0'"
                  @click.stop.prevent="addlabel(company_id)"
                >
            </span>
            <b-input-group 
            v-show="addinglabel==company_id"
              small class="col-3 pl-0 ml-0 py-0 my-0">
              <b-form-input
                small
                class="form-control-sm py-0"
                v-model="addinglabeltext"
                placeholder="Add label"
                type="text"
                @keyup.enter.prevent="saveaddlabel"
                @keyup.escape.prevent="addinglabel = 0"
                autocomplete="off"
                ref="addinglabel"
              >
              </b-form-input>
              <b-input-group-text class="py-0" slot="append">
                <b-btn
                  variant="link"
                  size="sm"
                  @click="addinglabel = 0"
                  class="p-0 i"
                >
                X
                </b-btn>
              </b-input-group-text>
            </b-input-group>
            </div>
          </div>
          </b-row>
        </b-card>
      </b-tab>
    </b-tabs>
  </div>
</template>
<script>

export default {
  components: {
  },
  name: 'Consultant',
  created() {
    this.countries_get();
    this.company_get();
  },
  data: function() {
    return {
      company_name: '',
      company_name_valid: null,
      company_address_1: '',
      company_address_valid: null,
      company_address_2: '',
      company_zip_code: '',
      company_zip_code_valid: null,
      company_city: '',
      company_city_valid: null,
      company_registration_number: '',
      company_registration_number_valid: null,
      company_country_id: 0,
      company_country_id_valid: null,
      countries: [],
      labels: [],
      addinglabel: 0,
      addinglabeltext: '',
      loading: true,
    }
  },
  computed: {
    company_id: {
      get() {
        return this.$store.state.currentcompany_id;
      }
    },
    emailinvalidfeedback() {
      if (this.email == '') { return "E-mail is invalid"; }
      // eslint-disable-next-line
      if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(this.email) == false) {
        return "Incorrect e-mail format";
      }
      return "E-mail already exists";
    }
  },
  watch: {
    company_id: function() {
      this.company_get()
    }
  },
  methods: {
    checkform() {
      var formok = true;
      this.company_name_valid = true;
      if (this.company_name == '') { 
        this.company_name_valid = false; 
        formok = false;
      }
      return formok;
    },
    company_create() {
      if (this.checkform()) {
        var company = {
          company_name: this.company_name,
          company_address_1: this.company_address_1,
          company_address_2: this.company_address_2,
          company_zip_code: this.company_zip_code,
          company_city: this.company_city,
          company_country_id: this.company_country_id,
          company_registration_number: this.company_registration_number,
        }
        this.$store.dispatch('company_create', { company: company })
        .then((resp) => {
          var company_id = resp.data.id;
          this.$store.dispatch('company_setcurrent',{ company_id: company_id })
          .then(() => {
            this.company_get();
          });
        });
      }
    },
    savefield(tablename,id,fieldname,value) {
      if ( id > 0 ) {
        if (this.checkform()) {
          var record = {
            id: id,
            [fieldname]: value,
          }
          this.$store.dispatch('field_save', { tablename: tablename,record: record })
          .then(() => {
            this.$store.dispatch('companychanged_set',{ company_id: this.company_id });
          });
        }
      }
    },
    company_get() {
      this.company_name = '';
      this.labels = [];
      if (this.company_id > 0) {
        this.$store.dispatch('company_fetch', { company_id: this.company_id })
        .then((resp) => {
          this.company_name = resp.data.company_name;
          this.company_address_1 = resp.data.company_address_1;
          this.company_address_2 = resp.data.company_address_2;
          this.company_zip_code = resp.data.company_zip_code;
          this.company_city = resp.data.company_city;
          this.company_country_id = resp.data.company_country_id;
          this.company_registration_number = resp.data.company_registration_number;
          this.labels = resp.data.labels;
          this.loading = false;
        });
      }
    },
    backtolist() {
      this.$store.dispatch('company_setcurrent',{ company_id: 0 })
    },
    conslabels_get() {
      this.$store.dispatch('company_fetch', { company_id: this.company_id })
      .then((resp) => {
        this.labels = resp.data.labels;
      });
    },
    saveaddlabel() {
      if (this.addinglabeltext != '') {
        var savelabel = {
          company_id: this.addinglabel,
          label: this.addinglabeltext,
        }
        this.$store.dispatch('companylabel_add', { label: savelabel })
        .then(()=> {
          this.conslabels_get();
          this.$store.dispatch('companylabelchanged_set', { company_id: this.company_id });
        });
      }
      this.addinglabel = 0;
      this.addinglabeltext = '';
    },
    addlabel(id) {
      this.addinglabel = id;
      this.addinglabeltext = '';
      this.$nextTick(() => this.$refs.addinglabel.focus())
    },
    removelabel(companylabel_id) {
      this.$store.dispatch('companylabel_delete', { id: companylabel_id })
      .then(()=> {
        this.conslabels_get();
        this.$store.dispatch('companylabelchanged_set', { company_id: this.company_id });
      });
    },
    countries_get() {
      this.$store.dispatch('countries_fetch')
      .then((resp) => {
        this.countries = [];
        for (var i=0;i<resp.data.result.length;i++) {
          var countryoption = {
            value: resp.data.result[i].id,
            text: resp.data.result[i].country_name,
          }
          this.countries.push(countryoption);
        }
      });
    },
  }
}
</script>
